import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import Anouncement from "./Announcement";
import { Outlet } from "react-router-dom";

function Layout() {
  return (
    <div className="app-container">
      <Header />
      <Anouncement />
      <main className="main-content">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}

export default Layout;
